import { GADataProps } from "@components/GAData/GAData";

import { StoryThreadLayout } from "./utils/helpers";
import { StoryThreadPayload } from "./utils/types";

type StoryThreadContentProps = Pick<StoryThreadPayload, "data">;

export default function StoryThreadPage({
  data,
  gaProps,
}: StoryThreadContentProps & { gaProps: GADataProps }): React.ReactElement {
  const Layout = StoryThreadLayout(data.entity.tag.urlPath);

  return <Layout data={data} gaProps={gaProps} />;
}
